
import { Component, Vue, Watch } from "vue-property-decorator";
import { Getter } from "vuex-class";
import HeaderService from "@/services/HeaderService";
import HeaderFooter from "@/models/Header_Footer/HeaderFooter";
import { AxiosResponse } from "axios";
import GlobalConfig from "@/GlobalConfig";
import AfiliadoService from "@/services/AfiliadoService";
import { PhotoBeneficiarioResponse } from "@/models/Dashboard/PhotoBeneficiarioResponse";
import { DashboardResponse } from "@/models/Dashboard/DashboardResponse";
import NoLoggedUser from "@/models/Sobrevivencia/NoLoggedUser/NoLoggedUser";
@Component({})
export default class NewHeader extends Vue {
  public header: HeaderFooter = new HeaderFooter();
  public headerService: HeaderService = new HeaderService();
  public umbracoBaseUrl: string = GlobalConfig.UMBRACO_BASE_URL;
  public logoUrl: string = "";
  public name: string = "";
  public today: string = "";
  public photoBeneficiarioResponse: PhotoBeneficiarioResponse = new PhotoBeneficiarioResponse();
  public afiliadoService: AfiliadoService = new AfiliadoService();
  public DashBoard: DashboardResponse = new DashboardResponse();
  @Getter("noLoggedUser") noLoggedUser: NoLoggedUser;
  @Getter("isLoggedIn") isLoggedIn: boolean;
  @Getter("displaySideBar") displaySideBar: boolean; 

  public async getPhoto() {
    await this.afiliadoService
      .GetPhotoBeneficiario(this.$store.state.user.cedula)
      .then((resp) => {
        this.photoBeneficiarioResponse = resp.data;
      })
      .catch((error) => {
        return error;
      });
  }

  public async getDashboard() {
    var response = await this.afiliadoService
      .getDashbord(this.$store.state.user.cedula)
      .then((resp) => {
        this.DashBoard = resp.data;
      })
      .catch((error) => {
        return error;
      });
  }
  async mounted() {
    var html = document.getElementsByTagName("html");
    for (var i = 0; i < html.length; i++) {
      html[i].style.overflow = "hidden";
    }

    if (this.isLoggedIn) {
      this.name = `${this.$store.state.user.primerNombre} ${this.$store.state.user.primerApellido}`;
    }

    await this.getHeaderData();
    await this.getPhoto();
    await this.getDashboard();
  }
  public getTodaysDate() {
    let date = new Date();
    let options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };

    this.today = date.toLocaleDateString("es-ES", options as any);
  }
  async getHeaderData() {
    this.headerService
      .get("MasterService/_umbracoMaster")
      .then((resp: AxiosResponse<HeaderFooter>) => {
        this.header = resp.data;
        this.logoUrl = `${this.umbracoBaseUrl}${resp.data.logo}`;
      });
  }
  public redirectHome() {
    window.location.href = GlobalConfig.PORTAL_BASE_URL;
  }
  async logOut() {
    this.$store.dispatch("logOut");
    this.redirectHome();
  }
  @Watch("isLoggedIn")
  public setName(value: boolean) {
    if (value)
      this.name = `${this.$store.state.user.primerNombre} ${this.$store.state.user.primerApellido}`;
  }


  get isDashboardDataAvaliable() {
    return (
      this.DashBoard != null &&
      this.DashBoard.response != null &&
      this.DashBoard.response.respCode == 200
    );
  }
  
  displaySideBarAction() {
  this.$store.dispatch("SetDisplaySideBarAction", !this.displaySideBar);

  this.$nextTick(() => {
    const sidebar = document.querySelector(".Bar") as HTMLElement;
    const shortLogo = document.querySelector(".logo-short") as HTMLElement;
    const logo = document.querySelector(".logo") as HTMLElement;
    const sec1Elements = document.getElementsByClassName("sec1") as HTMLCollectionOf<HTMLElement>;

    if (sidebar) {
      sidebar.classList.toggle("active", this.displaySideBar);
      sidebar.style.display = this.displaySideBar ? "block" : "none";
    }

    if (shortLogo && logo) {
      if (this.displaySideBar) {
        shortLogo.style.display = "none"; // Ocultar logo corto
        logo.style.display = "flex"; // Mostrar logo
      } else {
        shortLogo.style.display = "flex"; // Mostrar logo corto
        logo.style.display = "none"; // Ocultar logo normal
      }
    }

    for (let i = 0; i < sec1Elements.length; i++) {
      sec1Elements[i].style.minWidth = this.displaySideBar ? "250px" : "90px";
    }
  });
}

@Watch("displaySideBar")
OnDisplaySideBarChanged(value: boolean, oldValue: boolean) {
  const sidebar = document.querySelector(".Bar") as HTMLElement;
  const shortLogo = document.querySelector(".logo-short") as HTMLElement;
  const logo = document.querySelector(".logo") as HTMLElement;
  const sec1Elements = document.getElementsByClassName("sec1") as HTMLCollectionOf<HTMLElement>;

  if (shortLogo && logo) {
    shortLogo.style.display = value ? "none" : "flex"; // Ocultar cuando sidebar está activo
    logo.style.display = value ? "flex" : "none"; // Mostrar cuando sidebar está activo
  }

  for (let i = 0; i < sec1Elements.length; i++) {
    sec1Elements[i].style.minWidth = value ? "250px" : "90px";
  }

  if (sidebar) {
    if (value) {
      sidebar.style.display = "block"; // Hacerla visible si está oculta
      setTimeout(() => sidebar.classList.add("active"), 10); // Pequeño delay para animación
    } else {
      sidebar.classList.remove("active");
      setTimeout(() => (sidebar.style.display = "none"), 300); // Ocultarla después de la animación
    }
  }
}
  
}
